const ErrorMessage = Object.freeze({
  400: 'Dữ liệu gửi lên không hợp lệ',
  401: 'Bạn không có quyền truy cập',
  403: 'Bạn không có quyền truy cập',
  404: 'Kiểm tra URL hoặc endpoint có đúng không!',
  408: 'Thời gian kết nối đến server quá lâu, vui lòng kiểm tra kết nối mạng!',
  429: 'Gửi quá nhiều yêu cầu đồng thời, vui lòng thử lại sau ít phút!',
  500: 'Đã xảy ra lỗi từ server, vui lòng thử lại sau!',
  503: 'Dịch vụ tạm thời không hoạt động, vui lòng thử lại sau!',
  504: 'Server đang bận, vui lòng thử lại sau!',
})

export class HttpsError {
  constructor({ status, message, data }) {
    return {
      error: true,
      status: status,
      data,
      message:
        message ||
        ErrorMessage[status] ||
        'Đã xảy ra lỗi trong quá trình thực hiện',
    }
  }
}
